import { render, staticRenderFns } from "./Sendtroop.vue?vue&type=template&id=a570b5f8&scoped=true&"
import script from "./Sendtroop.vue?vue&type=script&lang=js&"
export * from "./Sendtroop.vue?vue&type=script&lang=js&"
import style0 from "./Sendtroop.vue?vue&type=style&index=0&id=a570b5f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a570b5f8",
  null
  
)

export default component.exports